import { useParams, Navigate } from "react-router-dom";
import { ALL_LOCATIONS, LocationContext } from "@/lib/locations";
import { WaitlistPopup } from "@/components/WaitlistPopup";
import SpanishBlogPage from "./SpanishBlogPage";

const RegionBlogPageEs = () => {
  const { region } = useParams<{ region: string }>();

  const locationData = ALL_LOCATIONS.find(loc => loc.slug === region || loc.regionSlug === region);

  if (!locationData) return <Navigate to="/es/blog" replace />;

  return (
    <LocationContext.Provider value={locationData}>
      <WaitlistPopup />
      <SpanishBlogPage />
    </LocationContext.Provider>
  );
};

export default RegionBlogPageEs;